/* src/app/private/components/application/delete-application/delete-application.component.scss */
/*# sourceMappingURL=delete-application.component.css.map */
